import React from "react";

const profileContext = React.createContext({});

export {profileContext};
